import { render, staticRenderFns } from "./SlipDetail.vue?vue&type=template&id=7f3e5be4"
import script from "./SlipDetail.vue?vue&type=script&lang=js"
export * from "./SlipDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports